/* Generated by scripts/generate.ts from src/locales. Do not edit by hand. */
import type { NamespaceSchema } from "../catalogue";

export interface FundOverviewCopy {
  introHeading: string;
  introFallback: string;
  valueProp: {
    heading: string;
    bulletAssets: string;
    bulletRate: (args: { bestRate: string | number }) => string;
    bulletRateWithDistribution: (args: { bestRate: string | number; distribution: string | number }) => string;
    bulletNotice: string;
  };
  selectNoticeHeading: string;
  compareTableHeading: string;
  compareFootnote: string;
  compareFootnoteDated: (args: { cutOff: string | number; sentBy: string | number }) => string;
  withdrawalExplainer: {
    heading: string;
    datesBody: (args: { count: number; dates: string | number }) => string;
    noticeBody: string;
    rateBody: string;
    tradeOffBody: string;
    exampleHeading: string;
    exampleBody: (args: { rate: string | number; withdrawalRate: string | number }) => string;
    whyHeading: string;
    whyBody: string;
  };
  readMoreCta: (args: { noticeMonths: string | number }) => string;
  readMoreCtaPlain: string;
  investNowCta: string;
  chat: {
    pillLabel: string;
    promptQuestion: (args: { fundName: string | number }) => string;
    promptCta: (args: { category: string | number }) => string;
  };
  webinar: {
    heading: string;
    title: (args: { fundName: string | number }) => string;
    cta: string;
  };
}

export const fundOverviewSchema: NamespaceSchema = {
  namespace: "fund-overview",
  keys: {
    "introHeading": [],
    "introFallback": [],
    "valueProp.heading": [],
    "valueProp.bulletAssets": [],
    "valueProp.bulletRate": ["bestRate"],
    "valueProp.bulletRateWithDistribution": ["bestRate", "distribution"],
    "valueProp.bulletNotice": [],
    "selectNoticeHeading": [],
    "compareTableHeading": [],
    "compareFootnote": [],
    "compareFootnoteDated": ["cutOff", "sentBy"],
    "withdrawalExplainer.heading": [],
    "withdrawalExplainer.datesBody": ["count", "dates"],
    "withdrawalExplainer.noticeBody": [],
    "withdrawalExplainer.rateBody": [],
    "withdrawalExplainer.tradeOffBody": [],
    "withdrawalExplainer.exampleHeading": [],
    "withdrawalExplainer.exampleBody": ["rate", "withdrawalRate"],
    "withdrawalExplainer.whyHeading": [],
    "withdrawalExplainer.whyBody": [],
    "readMoreCta": ["noticeMonths"],
    "readMoreCtaPlain": [],
    "investNowCta": [],
    "chat.pillLabel": [],
    "chat.promptQuestion": ["fundName"],
    "chat.promptCta": ["category"],
    "webinar.heading": [],
    "webinar.title": ["fundName"],
    "webinar.cta": [],
  },
};
